import { motion } from "framer-motion";
import { ArrowDown, ArrowUp } from "@phosphor-icons/react";
import { eur, num } from "./statsUtils";
import { CountUp } from "@/components/motion/CountUp";

const KPIS = [
  { key: "revenue", label: "Prihod", fmt: (v) => eur(v) },
  { key: "occupancy", label: "Zauzeće", fmt: (v) => `${num(v, 1)} %` },
  { key: "adr", label: "ADR", hint: "Prosječna cijena noćenja", fmt: (v) => eur(v, 2) },
  { key: "revpar", label: "RevPAR", hint: "Prihod po raspoloživoj noći", fmt: (v) => eur(v, 2) },
  { key: "nights", label: "Noćenja", fmt: (v) => num(v) },
  { key: "bookings", label: "Rezervacije", fmt: (v) => num(v) },
  { key: "avg_los", label: "Prosj. boravak", fmt: (v) => `${num(v, 1)} noći` },
  { key: "avg_lead", label: "Rezervirano unaprijed", fmt: (v) => `${num(v, 0)} dana` },
  { key: "cancellation_rate", label: "Stopa otkazivanja", fmt: (v) => `${num(v, 1)} %`, invert: true },
];

function Delta({ value, invert }) {
  if (value == null) return <span className="text-[11px] text-muted-foreground">— prošle god.</span>;
  const good = invert ? value <= 0 : value >= 0;
  const Icon = value >= 0 ? ArrowUp : ArrowDown;
  return (
    <span className={`inline-flex items-center gap-0.5 text-[11px] font-semibold ${good ? "text-emerald-600" : "text-rose-600"}`}>
      <Icon size={11} weight="bold" /> {Math.abs(value).toLocaleString("hr-HR")} %
      <span className="ml-1 font-normal text-muted-foreground">vs. prošla god.</span>
    </span>
  );
}

export function KpiGrid({ kpis, prev, deltas }) {
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 sm:gap-3 xl:grid-cols-5" data-testid="stats-kpis">
      {KPIS.map((k, i) => (
        <motion.div
          key={k.key}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.22, delay: i * 0.03, ease: "easeOut" }}
          className="rw-card p-3 sm:p-4"
          title={k.hint}
          data-testid={`stats-kpi-${k.key}`}
        >
          <p className="truncate text-[10px] font-semibold uppercase tracking-wider text-muted-foreground sm:text-xs">{k.label}</p>
          <p className="mt-1.5 truncate font-mono text-lg font-bold text-foreground sm:text-2xl">
            <CountUp value={kpis[k.key]} format={k.fmt} />
          </p>
          <div className="mt-1 flex flex-wrap items-center gap-x-2">
            <Delta value={deltas[k.key]} invert={k.invert} />
          </div>
          {prev && <p className="mt-0.5 truncate text-[10px] text-muted-foreground">Prošla god.: {k.fmt(prev[k.key])}</p>}
        </motion.div>
      ))}
    </div>
  );
}
